// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__v9PiL","list":"styles_list__2L2wD","forBeginners":"styles_forBeginners__EV45G"};